"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPantry = function SvgPantry(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 3)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    d: "m8.05 5.754.14-.742L5.5 3.5 2.77 5.012l.182.742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.535 3.556v-.842c-.69-.027-1.035-.232-1.035-.616 0-.576.568-.655 1.035-.655",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    d: "M.5.5h15v17H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.586 15 13 13.628V8h-3v7h1.586z",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4A4A4A",
    cx: 13,
    cy: 15,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.119 5.5-1.54.83.297 1.177h.617V13.5h4V7.507h.712l.208-1.166L6.866 5.5H4.119z",
    stroke: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.5v7M12 3h.51a1 1 0 0 1 1 1v4.5",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPantry);
var _default = exports["default"] = Memo;